import { Link } from "react-router-dom";
import { site } from "@/config/site";

export default function SubmitCta() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dim%20moody%20desk%20scene%20with%20scattered%20sealed%20envelopes%20and%20a%20warm%20desk%20lamp%20glow%2C%20cinematic%20editorial%20photography%2C%20deep%20shadows%2C%20no%20text&width=1600&height=700&seq=cta-kanliao-01&orientation=landscape"
          alt="看料爆料投稿通道的昏暗桌面氛围背景"
          title="看料爆料 - 我要投稿"
          className="h-full w-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/80 to-foreground-950/60"></div>

      <div className="relative mx-auto w-full max-w-shell px-4 py-16 md:px-6 md:py-24">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-accent-300">
            <span className="h-px w-6 bg-accent-400" aria-hidden="true"></span>
            投稿通道
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-tight text-background-50 md:text-4xl">
            手里有料？别让它烂在聊天记录里
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
            无论是截图、录音、合同还是现场见闻，只要与公众利益相关，都可以交给我们。你可以选择匿名，也可以只留一个临时联系方式。
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/submit"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-7 py-3.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-500 md:text-base"
            >
              <i className="ri-mail-send-line text-lg" aria-hidden="true"></i>
              立即提交线索
            </Link>
            <span className="flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line" aria-hidden="true"></i>
              或发送至 {site.email}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}